export const lineHeight = {
  '105%': '105%',
  '110%': '110%',
  '115%': '115%',
  '120%': '120%',
  '125%': '125%',
  '135%': '135%',
  '140%': '140%',
}
